<template>
  <div>
    <div class="flex space-x-2 text-xs">
      <span class="global-button-xs cursor-pointer" @click="depositStatus = 1"
        >Yatırımı Onayla</span
      >
      <span class="global-button-xs cursor-pointer" @click="depositStatus = 2"
        >Yatırımı İptal Et</span
      >
      <span class="global-button-xs cursor-pointer" @click="depositStatus = 3"
        >Yatırımı Reddet</span
      >
    </div>
    <form
      v-if="depositStatus == 1"
      class="text-xs flex space-x-2 items-center"
      @submit.prevent="depositOk()"
    >
      <div>
        <label>Bankaya Yatırılan Tutar </label>
        <div class="flex space-x-2 items-center">
          <input
            type="text"
            class="uk-input w-full"
            v-model="form.amount_bank"
          />
          <select
            v-model="form.bank_currency_id"
            class="uk-select"
            style="width:100px"
          >
            <option
              v-for="template in $root.cache.getOptions[148]"
              :value="template.value"
              :key="template.value"
              >{{ template.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="self-end">
        <SaveButton title="Kaydet" />
      </div>
    </form>

    <form
      v-if="depositStatus >= 2"
      class="text-xs flex space-x-2 items-end"
      @submit.prevent="depositCanceled(depositStatus)"
    >
      <div class="flex-1">
        <label>Red Sebebi </label>
        <select
          class="uk-select w-full"
          v-model="selectedReason"
          @change="onReasonChange"
        >
          <option value="">Seçiniz</option>
          <option
            v-for="(reason, index) in rejectionReasons"
            :key="index"
            :value="reason"
          >
            {{ reason }}
          </option>
          <option value="other">Diğer</option>
        </select>
      </div>
      <div class="flex-1">
        <label>Ek Açıklama </label>
        <input type="text" class="uk-input w-full" v-model="customComment" placeholder="Ek açıklama giriniz" />
      </div>
      <div class="self-end">
        <SaveButton title="Kaydet" />
      </div>
    </form>
  </div>
</template>
<script>
import http from "../../../services/http";
import EventBus from "../../Ui/EventBus";
import SaveButton from "../../Ui/SaveButton.vue";
import REJECTION_REASONS from "../../../constants/rejectionReasons";
export default {
  props: ["id"],
  data() {
    return {
      depositStatus: null,
      form: {
        bank_currency_id:6
      },
      selectedReason: "",
      customComment: "",
      rejectionReasons: REJECTION_REASONS
    };
  },
  methods: {
    onReasonChange() {
      // Artık her zaman custom input gösterildiği için sadece boşluk kontrolü yapıyoruz
    },
    depositOk() {
      http.transaction
        .depositOk(this.id, this.form)
        .then(() => {
          EventBus.$emit("transactionReload", true);
        })
        .catch((msg) => {
          this.$root.errorMessage(msg.response.data);
        });
    },
    depositCanceled(type) {
      // Seçilen sebep ve custom comment'i birleştir
      let combinedComment = "";

      if (this.selectedReason && this.selectedReason !== "" && this.selectedReason !== "other") {
        combinedComment = this.selectedReason;
      }

      if (this.customComment && this.customComment.trim() !== "") {
        if (combinedComment) {
          combinedComment += " - " + this.customComment.trim();
        } else {
          combinedComment = this.customComment.trim();
        }
      }

      // Validation: En az birisi dolu olmalı
      if (!combinedComment || combinedComment.trim() === "") {
        this.$root.errorMessage("Lütfen red sebebini seçiniz veya giriniz");
        return;
      }

      this.form.comment = combinedComment;

      if (type == 3) {
        http.transaction
          .depositBlocked(this.id, this.form)
          .then(() => {
            EventBus.$emit("transactionReload", true);
          })
          .catch((msg) => {
            this.$root.errorMessage(msg.response.data);
          });
      } else {
        http.transaction
          .depositCanceled(this.id, this.form)
          .then(() => {
            EventBus.$emit("transactionReload", true);
          })
          .catch((msg) => {
            this.$root.errorMessage(msg.response.data);
          });
      }
    },
  },
  components: { SaveButton },
};
</script>
